<template>
  <div class="incomeStatistics column-me">
    <div class="tab-div row-me">
      <div class="item-tab column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">煎药中心日报</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">医院零售统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(2)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">订单统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(3)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===3}">项目销售统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===3}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(4)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===4}">项目销售明细</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===4}"></div>
      </div>
    </div>
    <!-- 煎药中心日报 -->
    <div class="card-div column-me flex1" v-show="tabIndex===0">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width200 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab1Item.hospitalName">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width200 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="tab1Item.mechName"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20 height100Per overflow-auto">
        <div class="column-me height100Per">
          <div class="height100Per">
            <el-table :data="tab1Item.tableData" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style" show-summary :summary-method="getSummaries1" height="100%">
              <el-table-column prop="createTime" label="日期" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="hospitalName" label="医院名称" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="mechName" label="机构名称" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderMoney" label="处方订单消耗" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="invalidPrescriptionCost" label="已作废中药处方成本" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="prescriptionCost" label="中药处方成本" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="fryingFee" label="处方煎药费成本" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="处方加工费成本" align="center" width="120" show-overflow-tooltip>
                <el-table-column prop="gjProcessFee" label="膏剂" align="center" width="120"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="tjProcessFee" label="贴剂" align="center" width="120"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="wjProcessFee" label="丸剂" align="center" width="120"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="sjProcessFee" label="散剂" align="center" width="120"
                                 show-overflow-tooltip></el-table-column>
              </el-table-column>
              <el-table-column prop="freightFee" label="处方运费成本" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="packageFee" label="处方包材成本" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="prescriptionProfit" label="处方订单利润" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 医院零售统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===1">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width200 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab2Item.hospitalName">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20">
        <div class="column-me">
          <div>
            <el-table :data="tab2Item.tableData" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style">
              <el-table-column type="index" label="序号" width="80" align="center"/>
              <el-table-column prop="hospitalName" label="医院名称" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNum" label="订单总量" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="invalidNum" label="作废订单量" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="effectiveNum" label="有效订单量" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="effectiveTypeNum" label="有效订单剂数" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderMoney" label="订单金额" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="prescriptionCost" label="处方成本价" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="prescriptionSale" label="处方零售价" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="fryingFee" label="代煎费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="processFee" label="加工费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="packageFee" label="包材费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="freightFee" label="运费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
          <div class="margin-top10">
            <el-pagination @current-change="handleCurrentChange2" :current-page.sync="tab2Item.pageNo"
                           layout="total, prev, pager, next, jumper" :total="tab2Item.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===2">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab3Item.hospitalName">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="tab3Item.mechName"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="订单状态" style="width: 100%;" filterable clearable
                     v-model="tab3Item.prescriptionStatus">
            <el-option v-for="item in statusArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="加工剂型" style="width: 100%;" filterable clearable
                     v-model="tab3Item.processType">
            <el-option v-for="item in processTypeArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="tab3Item.orderNo"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-input placeholder="客户姓名" style="width: 100%;" clearable v-model="tab3Item.patientName"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20">
        <div class="column-me">
          <div>
            <el-table :data="tab3Item.tableData" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style" show-summary sum-text="总计"
                      :summary-method="getSummaries3">
              <el-table-column prop="createTime" label="订单日期" align="center" width="150"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNo" label="处方订单号" align="center" width="250"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="hospitalName" label="医院名称" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="mechName" label="机构名称" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="patientName" label="客户姓名" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="statusName" label="订单状态" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="processType" label="加工剂型" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="drugNum" label="药品味数" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="doseNums" label="剂数" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="doseWeight" label="单剂重量" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="totalWeight" label="总剂重量" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="costPrice" label="处方成本价" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="salePrice" label="处方零售价" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="prescriptionProfit" label="处方利润" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="fryingFee" label="代煎费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="processFee" label="加工费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="packageFee" label="包材费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="freightFee" label="运费" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
          <div class="margin-top10">
            <el-pagination @current-change="handleCurrentChange3" :current-page.sync="tab3Item.pageNo"
                           layout="total, prev, pager, next, jumper" :total="tab3Item.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 项目销售统计 -->
    <div class="card-div column-me flex1" v-show="tabIndex===3">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab4Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab4Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab4Item.hospitalName">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="tab4Item.mechName"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="项目名称" style="width: 100%;" clearable v-model="tab4Item.projectName"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="row-me row-center margin-top20">
        <el-checkbox-group v-model="tab4Item.importNames" @change="clickSearch">
          <el-checkbox :label="item" v-for="(item,index) in ['药品费','代煎费','加工费','包材费','运费']"
                       :key="index">
            {{ item }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="margin-top20 column-me flex1 overflow-auto">
        <div class="flex1 overflow-auto">
          <el-table :data="tab4Item.tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" show-summary sum-text="总计"
                    :summary-method="getSummaries4">
            <el-table-column prop="projectName" label="项目名称" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="sn" label="药品编码" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="spec" label="品质规格" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageSpec" label="包装规格" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="unit" label="单位" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="nums" label="数量" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="costTotalPrice" label="成本总价" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="saleTotalPrice" label="零售总价" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="profit" label="利润" align="center"
                             show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="margin-top10">
          <el-pagination @current-change="handleCurrentChange4" :current-page.sync="tab4Item.pageNo"
                         layout="total, prev, pager, next, jumper" :total="tab4Item.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 项目销售明细 -->
    <div class="card-div column-me flex1" v-show="tabIndex===4">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab5Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab5Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="tab5Item.orderNo"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="客户姓名" style="width: 100%;" clearable v-model="tab5Item.patientName"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="tab5Item.hospitalName">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="tab5Item.mechName"></el-input>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="加工剂型" style="width: 100%;" filterable clearable v-model="tab5Item.processType">
            <el-option v-for="item in processTypeArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-left10">
          <el-select placeholder="项目类型" style="width: 100%;" filterable clearable v-model="tab5Item.projectType">
            <el-option v-for="item in projectTypeArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="row-me row-center margin-top20">
        <el-checkbox-group v-model="tab5Item.importNames" @change="clickSearch">
          <el-checkbox :label="item" v-for="(item,index) in ['药品费','代煎费','加工费','包材费','运费']"
                       :key="index">
            {{ item }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="margin-top20 column-me flex1 overflow-auto">
        <div class="flex1 overflow-auto">
          <el-table :data="tab5Item.tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" show-summary sum-text="总计"
                    :summary-method="getSummaries5" height="100%">
            <el-table-column prop="createTime" label="订单日期" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderNo" label="处方订单号" align="center" width="250"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="hospitalName" label="医院名称" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mechName" label="机构名称" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="patientName" label="客户姓名" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="类型" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="processType" label="加工剂型" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="projectName" label="项目名称" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="projectType" label="项目类型" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="sn" label="药品编码" align="center" show-overflow-tooltip
                             width="120"></el-table-column>
            <el-table-column prop="spec" label="品质规格" align="center" show-overflow-tooltip
                             width="120"></el-table-column>
            <el-table-column prop="packageSpec" label="包装规格" align="center" show-overflow-tooltip
                             width="120"></el-table-column>
            <el-table-column prop="unit" label="单位" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="nums" label="数量" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="costTotalPrice" label="成本总价" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="saleTotalPrice" label="零售总价" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="profit" label="利润" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <div class="margin-top10">
          <el-pagination @current-change="handleCurrentChange5" :current-page.sync="tab5Item.pageNo"
                         layout="total, prev, pager, next, jumper" :total="tab5Item.total">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    let that = this
    return {
      tabIndex: 0,
      hospitalArray: [],//医院下拉
      statusArray: [],//订单状态下拉
      processTypeArray: [
        {id: 0, name: '汤剂'}, {id: 0, name: '膏剂'}, {id: 0, name: '散剂'}, {id: 0, name: '颗粒剂'},
        {id: 0, name: '中医外治'}, {id: 0, name: '丸剂-水丸'}, {id: 0, name: '丸剂-大蜜丸'},
        {id: 0, name: '丸剂-水蜜丸'}, {id: 0, name: '丸剂-浓缩丸'},
      ],//剂型
      projectTypeArray: [{id: 0, name: '中药饮片'}, {id: 1, name: '服务费'}],//项目类型
      tab1Item: {//煎药中心日报
        selectDate1: '',
        selectDate2: '',
        hospitalName: '',
        mechName: '',
        tableData: [],
      },
      tab2Item: {//医院零售统计
        selectDate1: '',
        selectDate2: '',
        hospitalName: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      tab3Item: {//订单统计
        selectDate1: '',
        selectDate2: '',
        hospitalName: '',
        mechName: '',
        prescriptionStatus: '',
        processType: '',
        orderNo: '',
        patientName: '',
        tableData: [],
        summary: {},//总计
        pageNo: 1,
        total: 0,
      },
      tab4Item: {//项目销售统计
        selectDate1: '',
        selectDate2: '',
        hospitalName: '',
        mechName: '',
        projectName: '',
        importNames: [],
        tableData: [],
        summary: {},//总计
        pageNo: 1,
        total: 0,
      },
      tab5Item: {//项目销售明细
        selectDate1: '',
        selectDate2: '',
        orderNo: '',
        patientName: '',
        hospitalName: '',
        mechName: '',
        processType: '',
        projectType: '',
        importNames: [],
        tableData: [],
        summary: {},//总计
        pageNo: 1,
        total: 0,
      },
      disabledDate: function (time) {
        return time.getTime() > new Date(that.$method.getNowTime()).getTime();
      },
    }
  },
  // html加载完成之前
  created() {
    this.tab1Item.selectDate1 = this.$method.getNowDate()
    this.tab1Item.selectDate2 = this.$method.getNowDate()
    this.tab2Item.selectDate1 = this.$method.getNowDate()
    this.tab2Item.selectDate2 = this.$method.getNowDate()
    this.tab3Item.selectDate1 = this.$method.getNowDate()
    this.tab3Item.selectDate2 = this.$method.getNowDate()
    this.tab4Item.selectDate1 = this.$method.getNowDate()
    this.tab4Item.selectDate2 = this.$method.getNowDate()
    this.tab5Item.selectDate1 = this.$method.getNowDate()
    this.tab5Item.selectDate2 = this.$method.getNowDate()
    this.getHospital()
    this.getOrderStatusArray()
  },
  // html加载完成后执行。
  mounted() {
    this.getData()
  },
  // 事件方法执行
  methods: {
    //获取数据
    getData() {
      if (this.tabIndex === 0) {
        this.$postFormRequest('/admin/saleSettlement/incomeTotalDetail', {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          hospitalName: this.tab1Item.hospitalName,
          mechName: this.tab1Item.mechName,
        }).then((res) => {
          if (res) {
            this.tab1Item.tableData = res.data
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 1) {
        this.$postFormRequest('/admin/saleSettlement/hospitalSettlement', {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          hospitalName: this.tab2Item.hospitalName,
          pageNumber: this.tab2Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab2Item.tableData = res.data.list
            this.tab2Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 2) {
        this.$postFormRequest('/admin/saleSettlement/orderSettlement', {
          start: this.tab3Item.selectDate1,
          end: this.tab3Item.selectDate2,
          hospitalName: this.tab3Item.hospitalName,
          mechName: this.tab3Item.mechName,
          prescriptionStatus: this.tab3Item.prescriptionStatus,
          processType: this.tab3Item.processType,
          orderNo: this.tab3Item.orderNo,
          patientName: this.tab3Item.patientName,
          pageNumber: this.tab3Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab3Item.tableData = res.data.list
            this.tab3Item.total = res.data.totalRow
            this.tab3Item.summary = res.data1
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 3) {
        this.$postFormRequest('/admin/saleSettlement/projectSaleSettlement', {
          start: this.tab4Item.selectDate1,
          end: this.tab4Item.selectDate2,
          hospitalName: this.tab4Item.hospitalName,
          mechName: this.tab4Item.mechName,
          projectName: this.tab4Item.projectName,
          importNames: this.tab4Item.importNames,
          pageNumber: this.tab4Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab4Item.tableData = res.data.list
            this.tab4Item.total = res.data.totalRow
            this.tab4Item.summary = res.data1
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 4) {
        this.$postFormRequest('/admin/saleSettlement/projectSaleSettlementDetail', {
          start: this.tab5Item.selectDate1,
          end: this.tab5Item.selectDate2,
          orderNo: this.tab5Item.orderNo,
          patientName: this.tab5Item.patientName,
          hospitalName: this.tab5Item.hospitalName,
          mechName: this.tab5Item.mechName,
          processType: this.tab5Item.processType,
          projectType: this.tab5Item.projectType,
          importNames: this.tab5Item.importNames,
          pageNumber: this.tab5Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab5Item.tableData = res.data.list
            this.tab5Item.total = res.data.totalRow
            this.tab5Item.summary = res.data1
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    clickTab(index) {
      this.tabIndex = index
      this.getData()
    },
    clickSearch() {
      if (this.tabIndex === 0) {
        if (this.tab1Item.selectDate1 > this.tab1Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
      } else if (this.tabIndex === 1) {
        if (this.tab2Item.selectDate1 > this.tab2Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab2Item.pageNo = 1
      } else if (this.tabIndex === 2) {
        if (this.tab3Item.selectDate1 > this.tab3Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab3Item.pageNo = 1
      } else if (this.tabIndex === 3) {
        if (this.tab4Item.selectDate1 > this.tab4Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab4Item.pageNo = 1
      } else if (this.tabIndex === 4) {
        if (this.tab5Item.selectDate1 > this.tab5Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab5Item.pageNo = 1
      }
      this.getData()
    },
    clickClear() {
      if (this.tabIndex === 0) {
        this.tab1Item.selectDate1 = this.$method.getNowDate()
        this.tab1Item.selectDate2 = this.$method.getNowDate()
        this.tab1Item.hospitalName = ''
        this.tab1Item.mechName = ''
      } else if (this.tabIndex === 1) {
        this.tab2Item.selectDate1 = this.$method.getNowDate()
        this.tab2Item.selectDate2 = this.$method.getNowDate()
        this.tab2Item.hospitalName = ''
        this.tab2Item.pageNo = 1
      } else if (this.tabIndex === 2) {
        this.tab3Item.selectDate1 = this.$method.getNowDate()
        this.tab3Item.selectDate2 = this.$method.getNowDate()
        this.tab3Item.hospitalName = ''
        this.tab3Item.mechName = ''
        this.tab3Item.prescriptionStatus = ''
        this.tab3Item.processType = ''
        this.tab3Item.orderNo = ''
        this.tab3Item.patientName = ''
        this.tab3Item.pageNo = 1
      } else if (this.tabIndex === 3) {
        this.tab4Item.selectDate1 = this.$method.getNowDate()
        this.tab4Item.selectDate2 = this.$method.getNowDate()
        this.tab4Item.hospitalName = ''
        this.tab4Item.mechName = ''
        this.tab4Item.projectName = ''
        this.tab4Item.importNames = []
        this.tab4Item.pageNo = 1
      } else if (this.tabIndex === 4) {
        this.tab5Item.selectDate1 = this.$method.getNowDate()
        this.tab5Item.selectDate2 = this.$method.getNowDate()
        this.tab5Item.orderNo = ''
        this.tab5Item.patientName = ''
        this.tab5Item.hospitalName = ''
        this.tab5Item.mechName = ''
        this.tab5Item.processType = ''
        this.tab5Item.projectType = ''
        this.tab5Item.importNames = []
        this.tab5Item.pageNo = 1
      }
      this.getData()
    },
    clickExport() {
      let token = sessionStorage.getItem('token')
      let url = ''
      if (this.tabIndex === 0) {
        let param = {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          hospitalName: this.tab1Item.hospitalName,
          mechName: this.tab1Item.mechName,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/incomeTotalDetailExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 1) {
        let param = {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          hospitalName: this.tab2Item.hospitalName,
          pageNumber: this.tab2Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/hospitalSettlementExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 2) {
        let param = {
          start: this.tab3Item.selectDate1,
          end: this.tab3Item.selectDate2,
          hospitalName: this.tab3Item.hospitalName,
          mechName: this.tab3Item.mechName,
          prescriptionStatus: this.tab3Item.prescriptionStatus,
          processType: this.tab3Item.processType,
          orderNo: this.tab3Item.orderNo,
          patientName: this.tab3Item.patientName,
          pageNumber: this.tab3Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/orderSettlementExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 3) {
        let param = {
          start: this.tab4Item.selectDate1,
          end: this.tab4Item.selectDate2,
          hospitalName: this.tab4Item.hospitalName,
          mechName: this.tab4Item.mechName,
          projectName: this.tab4Item.projectName,
          importNames: this.tab4Item.importNames,
          pageNumber: this.tab4Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/projectSaleSettlementExport?' + this.$method.getParamsString(param)
      } else if (this.tabIndex === 4) {
        let param = {
          start: this.tab5Item.selectDate1,
          end: this.tab5Item.selectDate2,
          orderNo: this.tab5Item.orderNo,
          patientName: this.tab5Item.patientName,
          hospitalName: this.tab5Item.hospitalName,
          mechName: this.tab5Item.mechName,
          processType: this.tab5Item.processType,
          projectType: this.tab5Item.projectType,
          importNames: this.tab5Item.importNames,
          pageNumber: this.tab5Item.pageNo,
          token: token,
        }
        url = this.$baseUrl + '/admin/saleSettlement/projectSaleSettlementDetailExport?' + this.$method.getParamsString(param)
      }
      window.open(url)
    },
    handleCurrentChange2(pageNo) {
      this.tab2Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange3(pageNo) {
      this.tab3Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange4(pageNo) {
      this.tab4Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange5(pageNo) {
      this.tab5Item.pageNo = pageNo
      this.getData()
    },
    //煎药中心日报总计
    getSummaries1(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (index > 2) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = this.$method.toFixed(sums[index], 3)
          } else {
            sums[index] = 'N/A';
          }
        }
      });
      return sums;
    },
    //订单统计总计
    getSummaries3(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        let blankIndex = 7
        if (index === 0) {
          sums[index] = '总计';
        } else if (index === blankIndex) {
          sums[index] = this.tab3Item.summary.drugNum;
        } else if (index === blankIndex + 1) {
          sums[index] = this.tab3Item.summary.doseNums;
        } else if (index === blankIndex + 2) {
          sums[index] = this.tab3Item.summary.doseWeight;
        } else if (index === blankIndex + 3) {
          sums[index] = this.tab3Item.summary.totalWeight;
        } else if (index === blankIndex + 4) {
          sums[index] = this.tab3Item.summary.costPrice;
        } else if (index === blankIndex + 5) {
          sums[index] = this.tab3Item.summary.salePrice;
        } else if (index === blankIndex + 6) {
          sums[index] = this.tab3Item.summary.prescriptionProfit;
        } else if (index === blankIndex + 7) {
          sums[index] = this.tab3Item.summary.fryingFee;
        } else if (index === blankIndex + 8) {
          sums[index] = this.tab3Item.summary.processFee;
        } else if (index === blankIndex + 9) {
          sums[index] = this.tab3Item.summary.packageFee;
        } else if (index === blankIndex + 10) {
          sums[index] = this.tab3Item.summary.freightFee;
        }
      });
      return sums;
    },
    //项目销售统计总计
    getSummaries4(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        let blankIndex = 3
        if (index === 0) {
          sums[index] = '总计';
        } else if (index === blankIndex + 1) {
          sums[index] = this.tab4Item.summary.costTotalPrice;
        } else if (index === blankIndex + 2) {
          sums[index] = this.tab4Item.summary.saleTotalPrice;
        } else if (index === blankIndex + 3) {
          sums[index] = this.tab4Item.summary.profit;
        }
      });
      return sums;
    },
    //项目销售明细总计
    getSummaries5(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        let blankIndex = 11
        if (index === 0) {
          sums[index] = '总计';
        } else if (index === blankIndex + 1) {
          sums[index] = this.tab5Item.summary.costTotalPrice;
        } else if (index === blankIndex + 2) {
          sums[index] = this.tab5Item.summary.saleTotalPrice;
        } else if (index === blankIndex + 3) {
          sums[index] = this.tab5Item.summary.profit;
        }
      });
      return sums;
    },
    //获取医院下拉
    getHospital() {
      this.$getRequest('/admin/hospital/list', {}).then((res) => {
        if (res) {
          this.hospitalArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取订单状态下拉
    getOrderStatusArray() {
      this.$getRequest('/admin/order/selectStatus', {}).then((res) => {
        if (res) {
          this.statusArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.incomeStatistics {
  height: 100%;

  .tab-div {
    height: 60px;
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding-left: 20px;

    .item-tab {
      height: 60px;
      justify-content: flex-end;
      margin-right: 50px;

      .tab-title {
        font-size: 18px;
        color: #252630;

        &-active {
          color: #215AA0;
        }
      }

      .tab-line {
        width: 20px;
        height: 4px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    font-size: 18px;
    color: #252630;
    overflow: auto;
  }
}
</style>
